type optionsType = {
  top?: number;
  scrollIntoView?: boolean;
  scrollIntoViewOptions?: ScrollIntoViewOptions;
};

const defaultSettings: ScrollIntoViewOptions = { behavior: 'smooth', block: 'start', inline: 'start' };

export const scrollToElement = (element: HTMLElement, options?: optionsType) => {
  if (element) {
    const offsetPosition = element?.offsetTop + (options?.top || 0);
    if (options?.scrollIntoView) {
      const scrollIntoViewOptions = options?.scrollIntoViewOptions || defaultSettings;
      element.scrollIntoView({ ...scrollIntoViewOptions });
    } else {
      if (window) {
        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    }
  }
};
